import React from "react";
import { CustomList } from "components/index";
import { HoursCell } from "@/components/hours/cell";
import PercentageCell from "@/components/percentage/cell";
import { startOfWeek, addDays } from "date-fns";
import { RenderProfile } from "components/render-profile";
import { formatDateForAPI } from "utils/utils";
import { RangePresetFilter } from "components";

const ProjectsCell = ({ getValue }) => {
  const value = getValue();
  if (!Array.isArray(value) || value.length === 0) return <span>-</span>;
  return (
    <span className="" title={value.join(", ")}>
      {value.join(", ")}
    </span>
  );
};

const TeamAllocationSummaryList = ({ coordinatorId }) => {
  const columns = [
    {
      header: "Employee",
      accessorKey: "employee",
      cell: ({ getValue }) => <RenderProfile user={getValue()} />,
    },
    {
      header: "Planned",
      accessorKey: "planned_hours",
      cell: HoursCell,
    },
    {
      header: "Logged",
      accessorKey: "worked_hours",
      cell: HoursCell,
    },
    {
      header: "Draft",
      accessorKey: "draft_hours",
      cell: HoursCell,
    },
    {
      header: "Available",
      accessorKey: "available_hours",
      cell: HoursCell,
    },
    {
      header: "Planned %",
      accessorKey: "planned_percentage",
      cell: PercentageCell,
    },
    {
      header: "Planned Projects",
      accessorKey: "planned_projects",
      cell: ProjectsCell,
    },
    {
      header: "Worked Projects",
      accessorKey: "worked_projects",
      cell: ProjectsCell,
    },
  ];

  const today = new Date();
  const weekStart = startOfWeek(today, { weekStartsOn: 1 });
  const friday = addDays(weekStart, 4);

  const filters = {
    employeeId: coordinatorId,
    startDate: formatDateForAPI(weekStart),
    endDate: formatDateForAPI(friday),
  };

  return (
    <div key={coordinatorId}>
      <CustomList
        endPoint="custom-ui/get-team-allocation-summary"
        title="Team Allocation Summary"
        columns={columns}
        filters={filters}
        perPage={15}
        renderFilters={RangePresetFilter}
        storageKey={`overview-team-allocation-summary-${coordinatorId}`}
        inlineFilters={true}
      />
    </div>
  );
};

export default TeamAllocationSummaryList;
